import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
  .event-faq-area {
    padding: 65px 0;

    .sec-title {
      text-align: center;
      margin-bottom: 60px;

      h4 {
        color: ${colors.black1};
        font-weight: 600;
        text-transform: uppercase;
        margin-bottom: 0;
        position: relative;
        display: inline-block;

        span {
          color: ${colors.red};
        }

        &::after {
          content: "";
          position: absolute;
          width: 60%;
          height: 3px;
          background: ${colors.red};
          bottom: -10px;
          left: 20%;
          border-radius: 2px;
        }

        @media (max-width: 575px) {
          font-size: 20px;

          &::after {
            width: 50%;
            left: 25%;
          }
        }
      }
    }

    .faq-area {
      .faq-box {
        .faq-item {
          margin-bottom: 22px;

          button.accordion-button {
            border: none;
            background: transparent;
            margin-bottom: 15px;
            display: block;
            width: 100%;
            padding: 0;
            text-align: left;
            position: relative;
            transition: all 0.3s ease;

            &:hover p {
              color: ${colors.red};
            }

            div.accordion-icon {
              background: ${colors.red};
              height: 18px;
              text-align: center;
              float: left;
              margin-right: 12px;
              position: relative;

              i {
                font-size: 20px;
                color: #ffffff;
                width: 32px;
                line-height: 18px;
                padding-left: 2px;
              }

              &::before {
                content: "";
                position: absolute;
                border-width: 8px 16px;
                border-style: solid;
                border-top-color: transparent;
                border-right-color: transparent;
                border-bottom-color: ${colors.red};
                border-left-color: transparent;
                top: -16px;
                left: 0;
                z-index: 1;
              }

              &::after {
                content: "";
                position: absolute;
                border-width: 8px 16px;
                border-style: solid;
                border-top-color: ${colors.red};
                border-right-color: transparent;
                border-bottom-color: transparent;
                border-left-color: transparent;
                bottom: -16px;
                left: 0;
                z-index: 1;
              }
            }

            p {
              font-size: 16px;
              color: ${colors.black1};
              font-weight: 500;
              line-height: 18px;
              transition: color 0.3s ease;
            }
          }

          .accordion-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.2s ease-in-out;

            p {
              font-size: 14px;
              color: ${colors.text3};
              line-height: 28px;
              padding-left: 45px;
            }
          }

          .accordion-content.show {
            max-height: 100%;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    @media (max-width: 767px) {
      padding: 30px 0;

      .sec-title {
        margin-bottom: 40px;
      }
    }
  }
`;
